import {
  AdminEditExternalUrlRecipeArgs,
  Author,
  ExternalUrlRecipe,
  Publisher,
  RecipeTagManifest,
} from "@eatbetter/recipes-shared";
import { View } from "react-native";
import { EditExternalUrlRecipeOnSaveArgs, RecipeEditControl } from "@eatbetter/ui-shared";
import { useDispatch } from "../lib/AdminRedux";
import { editExternalUrlRecipe } from "../lib/recipes/AdminRecipesThunks";
import { addPhoto } from "../lib/photos/AdminPhotoThunks";
import { ParsedIngredientSummary } from "@eatbetter/items-shared";

export const EditExternalUrlRecipe = (props: {
  initialRecipe: ExternalUrlRecipe;
  parsedIngredients?: ParsedIngredientSummary[];
  tagManifest?: RecipeTagManifest;
  onDone: () => void;
}) => {
  const dispatch = useDispatch();

  const onSave = async (args: EditExternalUrlRecipeOnSaveArgs) => {
    const recipePhoto = args.newRecipePhoto ? await dispatch(addPhoto(args.newRecipePhoto)) : args.photo;
    const authorPhoto = args.newAuthorPhoto ? await dispatch(addPhoto(args.newAuthorPhoto)) : args.author?.photo;
    const publisherPhoto = args.newPublisherPhoto
      ? await dispatch(addPhoto(args.newPublisherPhoto))
      : args.publisher?.photo;

    const author: Author | undefined = args.author
      ? {
          ...args.author,
          photo: authorPhoto,
        }
      : args.author;

    const publisher: Publisher | undefined = args.publisher
      ? {
          ...args.publisher,
          photo: publisherPhoto,
        }
      : args.publisher;

    const editArgs: AdminEditExternalUrlRecipeArgs = {
      id: props.initialRecipe.id,
      version: props.initialRecipe.version,
      tagUpdate: args.tags ? { by: "admin", op: "replace", tags: args.tags } : undefined,
      updates: {
        title: args.title,
        description: args.description,
        ingredients: args.ingredients,
        instructions: args.instructions,
        author,
        publisher,
        canonicalUrl: args.canonicalUrl,
        photo: recipePhoto,
        time: args.time,
        recipeYield: args.recipeYield,
      },
    };

    await dispatch(editExternalUrlRecipe(editArgs));
    props.onDone();
  };

  return (
    <View>
      <RecipeEditControl
        type="adminExternalUrl"
        initialRecipe={props.initialRecipe}
        onSave={onSave}
        parsedIngredients={props.parsedIngredients}
        tagManifest={props.tagManifest}
      />
    </View>
  );
};
